import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbainashikcab() {



  const cardData =
  {
    keyword: 'Mumbai Nashik Cab  ',
    heading: 'Shambhu Cabs: Mumbai Nashik Cab ',
    headingDescription: 'Shambhu Cabs offers dependable Mumbai to Nashik Cab services, providing safe, comfortable, and hassle-free travel for families, friends, solo travelers, and corporate professionals heading to Nashik. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Nashik with spacious seating and well-maintained vehicles. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 customer support, Shambhu Cabs makes your trip to Nashik stress-free and convenient. From South Mumbai to Thane, Andheri to Navi Mumbai, Shambhu Cabs offers doorstep pickup and reliable Mumbai to Nashik cab services for all travelers seeking comfort, safety, and timely travel experience.',

    top: 'Top Places to Visit in Nashik with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga Temple",
    "description": "Trimbakeshwar Temple, one of the 12 Jyotirlingas of Lord Shiva, is Nashik’s most sacred pilgrimage site. Nestled in the Brahmagiri Hills, it is known for its unique three-faced lingam symbolizing Brahma, Vishnu, and Mahesh. The divine ambiance, ancient stone architecture, and spiritual significance make it a must-visit for devotees and travelers alike. Trimbakeshwar is also considered the origin of the sacred Godavari River."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is India’s most famous winery and a major attraction in Nashik. Spread across picturesque hills, it offers guided vineyard tours, wine-tasting sessions, gourmet dining, and photo-worthy views. Events like ‘SulaFest’ draw visitors from all over. Sula is the perfect blend of leisure, luxury, and scenic charm, making it a favorite weekend getaway spot."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a sacred region in Nashik associated with the Ramayana, where Lord Rama, Sita, and Lakshmana spent part of their exile. The area includes important temples such as Kalaram Temple, Sita Gufa, and Kapaleshwar Temple. With its mythological significance and spiritual atmosphere, Panchavati remains a deeply revered pilgrimage zone."
  },
  {
    "title": "Ramkund",
    "description": "Ramkund, located on the banks of the Godavari River, is Nashik’s holiest bathing ghat. It is believed that Lord Rama performed rituals here. Devotees come for sacred dips, especially during auspicious festivals. Ramkund also plays a central role in the Kumbh Mela — one of the world's largest religious gatherings held every 12 years."
  },
  {
    "title": "Pandavleni Caves",
    "description": "Pandavleni Caves, dating back over 2,000 years, are ancient Buddhist rock-cut caves showcasing intricate carvings, prayer halls, and chambers. Located atop a hill, the site requires a short trek and offers panoramic views of Nashik city. It’s a great blend of archaeology, spirituality, and adventure."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills, believed to be the birthplace of Lord Hanuman, is a popular trekking and spiritual spot near Nashik. The trail passes through lush greenery, ancient temples, and scenic plateaus. With mythological importance and natural beauty, Anjaneri appeals to both trekkers and devotees."
  },
  {
    "title": "Someshwar Waterfall (Someshwar–Gangapur Road)",
    "description": "Someshwar Waterfall, also known as Dudhsagar (not to be confused with Goa’s), is a monsoon favorite near Nashik. Surrounded by greenery and located close to the Gangapur Dam area, it offers a refreshing escape from the city’s heat. The peaceful environment makes it ideal for families and nature lovers."
  },
  {
    "title": "Coin Museum",
    "description": "The Coin Museum in Nashik — the only one of its kind in Asia — offers a unique look into India’s numismatic history. It displays ancient coins, minting machinery, and historical exhibits that highlight different eras of Indian currency. For history buffs, it is an educational and fascinating stop."
  },
  {
    "title": "Gangapur Dam",
    "description": "Gangapur Dam, built across the Godavari River, is a scenic spot known for peaceful sunsets, breezy weather, and beautiful views of the water body surrounded by hills. It’s a popular relaxation area, especially during monsoon and winter, offering a serene retreat close to Nashik city."
  },
  {
    "title": "Saptashrungi Temple",
    "description": "Located about 60 km from Nashik, Saptashrungi Temple is one of Maharashtra’s Shakti Peethas. Perched atop a mountain with 500+ steps or ropeway access, it offers divine blessings and sweeping valley views. The temple’s serene environment and devotional energy make it one of the region’s most important shrines."
  }
],


 "services": [
  {
    "name": "Mumbai to Nashik Taxi Service",
    "description": "Mumbai to Nashik Taxi Service provides dependable and comfortable intercity transportation for travelers visiting the rapidly developing city of Nashik. With clean, well-maintained cabs, trained long-route chauffeurs, and flexible pickup options from any location in Mumbai, this service ensures a stress-free journey across the Mumbai–Nashik Expressway. Ideal for business travelers, pilgrims, families, and tourists, the service guarantees timely arrivals, smooth highway travel, route flexibility, and 24/7 support throughout your trip."
  },
  {
    "name": "Nashik to Mumbai Cab Booking",
    "description": "Nashik to Mumbai Cab Booking allows passengers to reserve reliable return or one-way rides from Nashik to Mumbai with instant confirmation and transparent pricing. Travelers can choose between sedans, SUVs, premium cars, and chauffeur-driven vehicles based on their comfort needs. The service is designed to offer smooth intercity travel, professional drivers familiar with the Nashik–Mumbai route, and doorstep pickup from any part of Nashik, including Panchavati, Gangapur Road, and Pathardi."
  },
  {
    "name": "Mumbai–Nashik Ride",
    "description": "Mumbai–Nashik Ride offers seamless long-distance travel between Mumbai and Nashik with quick booking, flexible departure times, and experienced drivers for highway driving. Whether traveling to Nashik for work commitments, wine tourism, pilgrimage at Trimbakeshwar, or visiting vineyards like Sula, this service ensures comfort, safety, and convenience. All vehicles undergo regular checks, providing a premium and reliable ride experience across the scenic Mumbai–Nashik corridor."
  },
  {
    "name": "Intercity Cab Mumbai to Nashik",
    "description": "Intercity Cab Mumbai to Nashik provides a smooth and efficient travel experience for passengers seeking a reliable outstation taxi service. The service features spacious vehicles, AC comfort, courteous drivers, and complete transparency in fares. Ideal for family trips, office travel, vineyard visits, and weekend getaways, this intercity cab service ensures timely drop-offs, safe driving, and a relaxed journey throughout the Mumbai–Nashik route."
  },
  {
    "name": "Best Taxi Mumbai Nashik",
    "description": "Best Taxi Mumbai Nashik delivers top-quality travel with premium service standards, ensuring maximum comfort and safety for passengers. Offering a wide fleet of sedans, SUVs, and luxury vehicles, it caters to personal, family, and business travel needs. Drivers are well-trained in long-route driving and provide smooth, punctual, and hassle-free travel through the Mumbai–Nashik Expressway, making it one of the most reliable taxi choices."
  },
  {
    "name": "One-Way Cab Mumbai Nashik",
    "description": "One-Way Cab Mumbai Nashik is an economical option for travelers who only need a single-drop service to Nashik. With no return fare, the service offers great value for those relocating, traveling for business, or planning stays in Nashik. Passengers benefit from punctual pickups, comfortable cabs, and flexible scheduling, making this one-way service a preferred choice for budget-friendly long-distance travel."
  },
  {
    "name": "Mumbai Nashik Car Rental",
    "description": "Mumbai Nashik Car Rental offers travelers a variety of car rental options suitable for single-day trips, multi-day travel, and sightseeing visits. From compact sedans to spacious SUVs, travelers can choose the ideal car for their comfort and budget. The service focuses on safety, reliability, and full travel convenience, making it perfect for families, groups, and corporate travelers heading to Nashik and nearby destinations."
  },
  {
    "name": "Mumbai Nashik Chauffeur Service",
    "description": "Mumbai Nashik Chauffeur Service provides luxury, convenience, and professionalism for travelers seeking a premium experience between Mumbai and Nashik. Chauffeurs are experienced, courteous, and trained in long-route driving, ensuring a smooth journey. Ideal for executives, business travelers, and families wanting extra comfort, this service offers high-end cars, privacy, and a relaxed, premium travel experience."
  },
  {
    "name": "Fastest Mumbai to Nashik Cab",
    "description": "Fastest Mumbai to Nashik Cab ensures quick, time-efficient travel with experienced drivers who understand the fastest, safest routes along the Mumbai–Nashik highway. This service is suitable for urgent travel, business meetings, airport transfers, and time-sensitive trips. Passengers benefit from well-maintained vehicles, minimal travel delays, and priority pickup options, ensuring they reach their destination on time."
  },
  {
    "name": "Affordable Mumbai Nashik Taxi",
    "description": "Affordable Mumbai Nashik Taxi offers cost-effective intercity travel with transparent pricing and no hidden charges. Budget-friendly sedans, shared options, and competitive rates make this service ideal for students, families, and frequent travelers. Despite being economical, it maintains high standards of comfort, safety, and reliability throughout the entire journey."
  },
  {
    "name": "SUV Cab Mumbai Nashik",
    "description": "SUV Cab Mumbai Nashik provides spacious and comfortable travel for families, groups, and corporate teams. Ideal for vineyard tours, weekend getaways, and long-distance family travel, SUV cabs offer extra luggage space, powerful performance on highways, and a smooth ride. Perfect for those seeking added comfort and roominess on the Mumbai–Nashik route."
  },
  {
    "name": "Sedan Cab Mumbai Nashik",
    "description": "Sedan Cab Mumbai Nashik offers a comfortable and affordable travel option for solo travelers and small families. Sedans provide great mileage, smooth AC comfort, and a relaxed ride for the entire Mumbai–Nashik journey. With trained drivers and well-maintained vehicles, this service ensures efficient, economical, and comfortable intercity travel."
  },
  {
    "name": "Mumbai Nashik Outstation Taxi",
    "description": "Mumbai Nashik Outstation Taxi is designed for long-distance travelers looking for reliability, comfort, and punctuality. With 24/7 availability, customizable routes, multiple vehicle choices, and experienced drivers, this outstation taxi ensures an enjoyable and stress-free journey for both leisure and business purposes."
  },
  {
    "name": "24×7 Mumbai Nashik Cab",
    "description": "24×7 Mumbai Nashik Cab provides round-the-clock availability for passengers traveling at any hour, including early morning and late-night departures. Ideal for emergencies, corporate travel, or urgent family trips, this service ensures prompt response, safe travel, and continuous support throughout the entire journey."
  },
  {
    "name": "Premium Cab Mumbai Nashik",
    "description": "Premium Cab Mumbai Nashik offers luxury travel with high-end vehicles such as premium sedans, executive SUVs, and chauffeur-driven cars. Perfect for corporate executives, VIP travel, and travelers seeking comfort, this service delivers superior interiors, smooth rides, and a fully personalized travel experience along the Mumbai–Nashik route."
  },
  {
    "name": "Mumbai Nashik AC Taxi",
    "description": "Mumbai Nashik AC Taxi provides fully air-conditioned cabs designed for comfort during long-distance travel. Passengers enjoy a smooth, temperature-controlled ride regardless of weather conditions. Ideal for families, elderly passengers, and business travelers, this service ensures a peaceful and comfortable journey."
  },
  {
    "name": "Mumbai Nashik Highway Cab",
    "description": "Mumbai Nashik Highway Cab is perfect for travelers looking for a safe and scenic ride across the Mumbai–Nashik Highway. With trained highway drivers, well-maintained cabs, and smooth route handling, this service ensures a pleasant journey through expressway stretches and hilly terrain."
  },
  {
    "name": "Corporate Cab Mumbai Nashik",
    "description": "Corporate Cab Mumbai Nashik provides professional and punctual cab services tailored for business travelers and corporate teams. Offering executive cars, on-time pickups, privacy, and comfortable seating, this service is perfect for meetings, events, corporate travel, and business-related trips between Mumbai and Nashik."
  }
],

"tableData": [
  ["Mumbai to Nashik Taxi Service", "Nashik to Mumbai Cab Booking"],
  ["Mumbai–Nashik Ride", "Intercity Cab Mumbai to Nashik"],
  ["Best Taxi Mumbai Nashik", "One-Way Cab Mumbai Nashik"],
  ["Mumbai Nashik Car Rental", "Mumbai Nashik Chauffeur Service"],
  ["Fastest Mumbai to Nashik Cab", "Affordable Mumbai Nashik Taxi"],
  ["SUV Cab Mumbai Nashik", "Sedan Cab Mumbai Nashik"],
  ["Mumbai Nashik Outstation Taxi", "24×7 Mumbai Nashik Cab"],
  ["Premium Cab Mumbai Nashik", "Mumbai Nashik AC Taxi"],
  ["Mumbai Nashik Highway Cab", "Corporate Cab Mumbai Nashik"]
],




"whychoose": [
  {
    "WhyChooseheading": "Mumbai Nashik Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai Nashik cab services, ideal for business travel, winery tours, pilgrimages, and comfortable long-distance trips."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, spacious, and air-conditioned cabs that are regularly serviced to ensure a smooth and safe journey to Nashik."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long-Distance Routes",
    "WhyChoosedescription": "Our skilled drivers are familiar with the Mumbai to Nashik highway route, ensuring a comfortable, safe, and timely travel experience."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing for your Mumbai Nashik cab ride—fuel, tolls, and driver allowances included with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to help with bookings, travel queries, and route assistance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Outstation Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customizable rental packages tailored to your Mumbai to Nashik travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every journey to ensure a hygienic and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making your Mumbai to Nashik journey smooth and stress-free."
  }
]
















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Nashik cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Nashik cab services with experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Nashik cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Nashik cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for long-distance travel to Nashik.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Nashik route?',
    answer: 'Yes, all our drivers are licensed, professional, and familiar with the Mumbai to Nashik route for a safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Nashik cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere in Nashik.',
  },
  {
    question: 'Is the Mumbai to Nashik cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Nashik cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Nashik cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for your well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Nashik cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Nashik journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Nashik travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Gupta',
    feedback: 'Shambhu Cabs made our Mumbai to Nashik journey smooth and hassle-free. Excellent service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Kamat',
    feedback: 'Very professional and reliable Mumbai to Nashik cab service. Highly recommended!',
    rating: 5,
  },
];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Nashik Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-nashik-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Nashik cab services with clean vehicles, expert drivers, and affordable fares. Choose from sedan, SUV, and premium car options for one-way or round-trip travel. Enjoy fast, safe, and comfortable intercity travel between Mumbai and Nashik.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-nashik-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Nashik Cab | Affordable Taxi Service | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Nashik cab services with Shambhu Cabs. Affordable fares, clean cars, professional drivers, and comfortable one-way or round-trip taxi options. 24×7 Mumbai–Nashik cab service available."
  />

  <meta
    name="keywords"
    content="Mumbai to Nashik Taxi Service, Nashik to Mumbai Cab Booking, Mumbai–Nashik Ride, Intercity Cab Mumbai to Nashik, Best Taxi Mumbai Nashik, One-Way Cab Mumbai Nashik, Mumbai Nashik Car Rental, Mumbai Nashik Chauffeur Service, Fastest Mumbai to Nashik Cab, Affordable Mumbai Nashik Taxi, SUV Cab Mumbai Nashik, Sedan Cab Mumbai Nashik, Mumbai Nashik Outstation Taxi, 24×7 Mumbai Nashik Cab, Premium Cab Mumbai Nashik, Mumbai Nashik AC Taxi, Mumbai Nashik Highway Cab, Corporate Cab Mumbai Nashik"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbainashikcab;